import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { USER_ROLE } from './user.model';
import { UserService } from './user.service';

export function CanAccessRoute(roles: USER_ROLE[]): CanMatchFn;
export function CanAccessRoute(...roles: USER_ROLE[]): CanMatchFn;
export function CanAccessRoute(...args: [USER_ROLE[]] | USER_ROLE[]): CanMatchFn {
  const roles: USER_ROLE[] = Array.isArray(args[0]) ? args[0] : (args as USER_ROLE[]);
  return () => inject(UserService).user$.pipe(map((user) => roles.includes(user.role)));
}

export function CannotAccessRoute(forbidenRoles: USER_ROLE[]): CanMatchFn;
export function CannotAccessRoute(...forbidenRoles: USER_ROLE[]): CanMatchFn;
export function CannotAccessRoute(...args: [USER_ROLE[]] | USER_ROLE[]): CanMatchFn {
  const forbidenRoles: USER_ROLE[] = Array.isArray(args[0]) ? args[0] : (args as USER_ROLE[]);
  return () => inject(UserService).user$.pipe(map((user) => !forbidenRoles.includes(user.role)));
}

export const AllowOnlyAdmin = CanAccessRoute(USER_ROLE.ADMIN);
export const ForbidAnonymous = CannotAccessRoute(USER_ROLE.ANON);
